<template>
  <span @click="setSliderToSlideWithId()">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    slideId: { type: Number, required: true }
  },

  methods: {
    setSliderToSlideWithId() {
      this.$root.$emit('setSliderToSlideWithId', this.slideId);
    }
  }
}
</script>
